//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	angular.module('pphhApp')
		.service("pdfDownloadActionController", ["$window", "pphhEnv", PdfDownloadActionController]);

	function PdfDownloadActionController($window, pphhEnv) {
		this.performAction = performAction;

		function performAction(scope, row) {
			var id = row.id;
			var url = pphhEnv.global.contextPath + "/pphhNav/exportPDF/" + scope.entity.entityName + "/" + id + "/" + scope.cicloId;
			$window.open(url);
		}
	}

})();